import dayjs from 'dayjs'
import { DATE_PARAM_FORMAT } from './constants'
import type { DailyCloseFormValues } from './filterToRequest'

export interface DailyCloseSearchQuery {
  shipperCode?: string
  closeDateFrom?: string
  closeDateTo?: string
  warehouseName?: string
  logisticsServiceType?: string
}

export const toSearchQuery = (values: DailyCloseFormValues): DailyCloseSearchQuery => {
  const [from, to] = values.closeDateRange ?? []
  return {
    ...(values.shipperCode ? { shipperCode: values.shipperCode } : {}),
    ...(from ? { closeDateFrom: from.format(DATE_PARAM_FORMAT) } : {}),
    ...(to ? { closeDateTo: to.format(DATE_PARAM_FORMAT) } : {}),
    ...(values.warehouseName ? { warehouseName: values.warehouseName } : {}),
    ...(values.logisticsServiceType ? { logisticsServiceType: values.logisticsServiceType } : {}),
  }
}

const text = (value: unknown): string | undefined => (typeof value === 'string' && value ? value : undefined)

const restoreDate = (value: unknown) => {
  const raw = text(value)
  if (!raw || !/^\d{8}$/.test(raw)) return null
  const parsed = dayjs(`${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`)
  return parsed.isValid() && parsed.format(DATE_PARAM_FORMAT) === raw ? parsed : null
}

export const fromSearchQuery = (query: Partial<DailyCloseSearchQuery>, defaults: DailyCloseFormValues): DailyCloseFormValues => {
  const from = restoreDate(query.closeDateFrom)
  const to = restoreDate(query.closeDateTo)
  const shipperCode = text(query.shipperCode)
  const logisticsServiceType = text(query.logisticsServiceType)

  return {
    shipperCode: shipperCode ?? (logisticsServiceType ? undefined : defaults.shipperCode),
    closeDateRange: from && to ? [from, to] : defaults.closeDateRange,
    warehouseName: text(query.warehouseName),
    logisticsServiceType,
  }
}
